var e4 = e4 || {},
    eldorado = eldorado || {};
(function () {
    'use strict';
    eldorado.ga4 = {
        jProductList: jQuery('.js-e-productlist'),
        init: function () {
            if (window.dataLayer !== undefined) {
                eldorado.ga4.bindEvents();
            } else {
                e4.util.debug([
                    'window.google_tag_manager = ',
                    window.google_tag_manager,
                    'Not binding anything.'
                ], false);
            }
        },
        bindEvents: function () {
            if (eldorado.ga4.jProductList.length > 0) {
                eldorado.ga4.jProductList.on('builded.e4.productlist', function (event, jsonData) {
                    eldorado.ga4.productList()
                });
            }
            jQuery(document)
                .on('productadded.e4.cart', eldorado.ga4.addToCart)
                .on('orderlinedeleted.e4.cart', eldorado.ga4.removeFromCart);
        },
        pushDataLayer: function (objDataLayer) {
            if (window.dataLayer !== undefined) {
                dataLayer.push(objDataLayer);
            } else {
                e4.util.debug([
                    'window.dataLayer = ',
                    window.dataLayer,
                    'Not pushing anything.'
                ], false);
            }
        },
        productList: function () {
            const jGa4Data = jQuery('.js-eldorado-ga4-product-list-json');
            if(jGa4Data.length > 0) {
                var items = JSON.parse(jGa4Data.text());
                eldorado.ga4.pushDataLayer({ecommerce: null});
                eldorado.ga4.pushDataLayer({
                    'event': 'view_item_list',
                    'ecommerce': {
                        'item_list_id': 'product_list',
                        'item_list_name': 'Product list',
                        'items': items
                    }
                });
            }
            
        },
        clickProductLink(productId, productName, productVariant, productCurrency, productPrice, groupId, groupName) {
            eldorado.ga4.pushDataLayer({ecommerce: null});
            eldorado.ga4.pushDataLayer({
                'event': 'select_item',
                'ecommerce': {
                    'item_list_id': groupId ? groupId : 'product_list_item',
                    'item_list_name': groupName ? groupName : 'Product list Item',
                    'items': [{
                        'item_id': productId,
                        'item_name': productName,
                        'currency': productCurrency,
                        'item_list_id': groupId ? groupId : 'product_list_item',
                        'item_list_name': groupName ? groupName : 'Product list Item',
                        'item_variant': productVariant,
                        'price': productPrice
                    }]
                }
            });
        },
        addToCart: function (event, objData) {
            if (objData.cart.lastAdded.length > 0) {
                console.log(objData);
                eldorado.ga4.pushDataLayer({ecommerce: null});
                eldorado.ga4.pushDataLayer({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'currency': objData.cart.currencyCode,
                        'value': objData.cart.lastAdded[0].totalPrice,
                        'items': [{
                            'item_id': objData.cart.lastAdded[0].number,
                            'item_name': objData.cart.lastAdded[0].name,
                            'price': objData.cart.lastAdded[0].unitPrice,
                            'quantity': objData.cart.lastAdded[0].quantity
                        }]
                    }
                });
            }
        },
        removeFromCart: function (event, objData) {
            console.log(objData);
            eldorado.ga4.pushDataLayer({ecommerce: null});
            eldorado.ga4.pushDataLayer({
                'event': 'remove_from_cart',
                'ecommerce': {
                    'currency': objData.currencyCode,
                    'value': objData.price,
                    'items': [{
                        'item_id': objData.number.toString(),
                        'item_name': objData.name,
                        'price': objData.price,
                        'quantity': objData.quantity
                    }]
                }
            });
        }
    }
}());